import React from 'react';
import { abgGraphqlClient, ProxyGraphClients } from '@atlassian/temp-client-utils';
import {
  FetchQuotesForTransactionAccountQuery,
  FetchQuotesForTransactionAccountQueryVariables,
  FilterOption,
} from '@css-xp/graphtypes/src/generated-types-sxp';
import { usePersistedCacheQuery } from '@css-xp/ppc-custom-hooks';
import { DEFAULT_PAGE_SIZE, QUOTE_TABLE_DEFAULT_SORT_OPTIONS } from '@css-xp/ppc-constants';
import { fetchQuotesForTransactionAccount } from '../queries/fetch-quotes-for-txa';
import { getDefaultFilterOptions } from '../../utils/quote-utils';

interface UseFetchQuotesForTransactionAccountQueryVariables {
  transactionAccountId: string;
  filterOptions: FilterOption;
  shouldFetchLineItems?: boolean;
}

export const useFetchQuotesForTransactionAccount = ({
  transactionAccountId,
  filterOptions,
  shouldFetchLineItems = false,
}: UseFetchQuotesForTransactionAccountQueryVariables) => {
  const sxpClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.SXP), []);
  const defaultFilterOptions = getDefaultFilterOptions({ transactionAccountId, filterOptions });
  return usePersistedCacheQuery<FetchQuotesForTransactionAccountQuery, FetchQuotesForTransactionAccountQueryVariables>(
    fetchQuotesForTransactionAccount,
    {
      variables: {
        searchOptions: {
          first: DEFAULT_PAGE_SIZE,
          sort: QUOTE_TABLE_DEFAULT_SORT_OPTIONS,
        },
        filterOptions: defaultFilterOptions,
        fetchLineItems: shouldFetchLineItems,
      },
      skip: !transactionAccountId,
      client: sxpClient,
    }
  );
};
